var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpleabilidad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 128,
    viewBox: "0 0 131 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9062 100V96.302C26.9062 94.912 26.368 93.574 25.4011 92.562C23.3536 90.418 19.6608 86.552 17.1989 83.976C15.6064 82.308 14.7188 80.104 14.7188 77.814C14.7188 70.382 14.7188 53.164 14.7188 43.996C14.7188 40.684 17.4447 38 20.8084 38H20.8166C22.4314 38 23.9812 38.632 25.1228 39.756C26.2644 40.88 26.9062 42.406 26.9062 43.996C26.9062 48.538 26.9062 54 26.9062 54",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.094 100V96.302C104.094 94.912 104.632 93.574 105.599 92.562C107.646 90.418 111.339 86.552 113.801 83.976C115.394 82.308 116.281 80.104 116.281 77.814C116.281 70.382 116.281 53.164 116.281 43.996C116.281 40.684 113.555 38 110.192 38H110.183C108.569 38 107.019 38.632 105.877 39.756C104.736 40.88 104.094 42.406 104.094 43.996C104.094 48.538 104.094 54 104.094 54",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4062 112.758V102.892C59.4062 102.126 59.0975 101.39 58.545 100.848C57.9945 100.304 57.247 100 56.4691 100C49.9488 100 34.3325 100 27.8122 100C27.0342 100 26.2867 100.304 25.7362 100.848C25.1837 101.39 24.875 102.126 24.875 102.892C24.875 106.656 24.875 112.758 24.875 112.758",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5938 112.758V102.892C71.5938 102.126 71.9025 101.39 72.455 100.848C73.0055 100.304 73.753 100 74.5309 100C81.0512 100 96.6675 100 103.188 100C103.966 100 104.713 100.304 105.264 100.848C105.816 101.39 106.125 102.126 106.125 102.892C106.125 106.656 106.125 112.758 106.125 112.758",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3749 100V89.018C57.3749 84.14 55.3437 79.476 51.7545 76.112C47.109 71.758 40.6314 65.688 36.5404 61.852C34.3751 59.824 30.9646 59.866 28.8521 61.946L28.8481 61.95C26.6543 64.11 26.6543 67.614 28.8481 69.774C32.7237 73.592 38.0435 78.828 38.0435 78.828",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.625 100V89.018C73.625 84.14 75.6562 79.476 79.2455 76.112C83.8909 71.758 90.3686 65.688 94.4595 61.852C96.6248 59.824 100.035 59.866 102.148 61.946L102.152 61.95C104.346 64.11 104.346 67.614 102.152 69.774C98.2762 73.592 92.9564 78.828 92.9564 78.828",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 60C79.5229 60 90.8906 48.8071 90.8906 35C90.8906 21.1929 79.5229 10 65.5 10C51.4771 10 40.1094 21.1929 40.1094 35C40.1094 48.8071 51.4771 60 65.5 60Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5464 31.448C47.5965 26.034 51.0192 21.11 56.3228 18.286",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5625 27C68.6342 25.786 67.1595 25 65.5 25C62.6969 25 60.4219 27.24 60.4219 30C60.4219 32.76 62.6969 35 65.5 35C68.3031 35 70.5781 37.24 70.5781 40C70.5781 42.76 68.3031 45 65.5 45C63.8405 45 62.3658 44.214 61.4375 43",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 25V21",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 49V45",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpleabilidad);
export default __webpack_public_path__ + "static/media/empleabilidad.511c334a7aa3c87236b244ee92b37320.svg";
export { ForwardRef as ReactComponent };